import { Link } from 'react-router-dom';

export default function CoworkingHero() {
  return (
    <section
      className="relative min-h-[90vh] flex items-center"
      aria-labelledby="coworking-hero-title"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/159403d75a76d0cc8deba6f33cd24f20.jpg"
          alt="コワーキングスペース by favy 新宿"
          className="w-full h-full object-cover object-top"
          loading="eager"
          width="1600"
          height="900"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-32 sm:py-40 w-full">
        <Link
          to="/"
          className="inline-flex items-center text-white/60 hover:text-white mb-6 sm:mb-8 transition-colors cursor-pointer tracking-wide text-sm"
        >
          <i className="ri-arrow-left-line mr-2" aria-hidden="true"></i>
          トップに戻る
        </Link>

        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-6 flex-wrap">
            <span className="inline-block px-4 py-2 bg-emerald-500/20 text-emerald-400 text-xs tracking-[0.15em] rounded-full">
              favy × MeVER
            </span>
            <span className="inline-block px-3 py-1.5 bg-white/10 text-white/80 text-xs tracking-[0.1em] rounded-full">
              新宿駅徒歩5分
            </span>
            <span className="inline-block px-3 py-1.5 bg-emerald-500/30 text-emerald-300 text-xs tracking-[0.1em] rounded-full">
              体験可能
            </span>
          </div>

          <h1
            id="coworking-hero-title"
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extralight text-white mb-6 sm:mb-8 tracking-[0.08em] leading-tight"
          >
            好きを仕事に、
            <br />
            <strong className="font-light">MeVERと共に。</strong>
          </h1>

          <p className="text-base sm:text-lg md:text-xl font-extralight text-white/70 leading-relaxed mb-6 sm:mb-8 max-w-lg tracking-wide">
            新宿のコワーキングスペース by favyで、MeVER Chairを実際の作業環境でお試しいただけます。購入前に、あなたに最適な一脚を見つけてください。
          </p>

          {/* Quick Info */}
          <div className="flex flex-wrap gap-4 sm:gap-6 mb-8 sm:mb-10 text-white/60 text-sm font-extralight">
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-time-line text-emerald-400" aria-hidden="true"></i>
              </div>
              <span>9:00〜23:00</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-pin-line text-emerald-400" aria-hidden="true"></i>
              </div>
              <span>新宿三丁目駅 徒歩2分</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-price-tag-3-line text-emerald-400" aria-hidden="true"></i>
              </div>
              <span>550円/30分〜</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="https://appointment.mever.design/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-black text-sm font-medium tracking-[0.1em] hover:bg-white/90 transition-colors whitespace-nowrap rounded-lg cursor-pointer shadow-lg shadow-white/20"
            >
              <i className="ri-calendar-check-line mr-2" aria-hidden="true"></i>
              MeVER Chair 体験予約
              <i className="ri-arrow-right-line ml-2" aria-hidden="true"></i>
            </a>
            <a
              href="https://pass.workhub.site/spaces/drop-in/detail/KmPzAOl3HSsGdIqqdLxK"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center justify-center px-8 py-4 bg-emerald-500 text-white text-sm font-light tracking-[0.1em] hover:bg-emerald-600 transition-colors whitespace-nowrap rounded-lg cursor-pointer"
            >
              30分単位で使う（550円〜）
              <i className="ri-external-link-line ml-2" aria-hidden="true"></i>
            </a>
            <a
              href="https://pass.workhub.site/spaces/drop-in/detail/6Ps8hxhmSHpBPJmzziZo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-sm font-light tracking-[0.1em] hover:bg-white/20 transition-colors whitespace-nowrap rounded-lg cursor-pointer border border-white/20"
            >
              1日プランの予約（3,300円）
              <i className="ri-external-link-line ml-2" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
